export const TEST_STEP_DEFAULT_SORT = 'stepOrder,id';
export const TEST_STEP_PAGE_SIZE = 1000;
